<div class="container" *transloco="let t; prefix: 'profile'">
  <div class="panel">
    <div class="edit-header">
      <div class="header-title-section">
        <h1 class="header-title">{{ t('header') }}</h1>
        <p class="header-subtitle">{{ t('subtitle') }}</p>
      </div>
      <htx-button
        variant="tertiary"
        icon="save"
        (click)="save()"
        [disabled]="form.invalid || isSaving() || isOrganizationPending()"
      >
        {{ 'button.save' | transloco }}
      </htx-button>
    </div>

    @if (loadError()) {
      <htx-alert type="error">{{ t('loadError') }}</htx-alert>
    }

    @if (isLoading()) {
      <div class="form-sections">
        <htx-skeleton width="30%" height="1.1rem" borderRadius="4px"></htx-skeleton>
        <htx-skeleton width="100%" height="2.75rem" [lines]="6" gap="0.875rem" borderRadius="6px"></htx-skeleton>
      </div>
    } @else {
      <div class="form-sections">
        <htx-form-section
          [title]="t('sections.personalInfo')"
          [icon]="'person'"
          [formGroup]="form"
        >
          <htx-dropdown-field
            [ctrl]="form.controls.title"
            [label]="t('controls.title.label')"
            [options]="salutationOptions()"
          >
          </htx-dropdown-field>
          <htx-text-field [ctrl]="form.controls.firstName" [label]="t('controls.firstName.label')">
          </htx-text-field>
          <htx-text-field [ctrl]="form.controls.lastName" [label]="t('controls.lastName.label')">
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.email"
            [label]="t('controls.email.label')"
            [hint]="t('controls.email.hint')"
            type="email"
          >
          </htx-text-field>
          <htx-text-field [ctrl]="form.controls.position" [label]="t('controls.position.label')">
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.phoneNumber"
            [label]="t('controls.phoneNumber.label')"
          >
          </htx-text-field>
        </htx-form-section>
      </div>
    }
  </div>
</div>
